import type { RouteRecordRaw } from 'vue-router'
import { Layout } from '@/utils/routerHelper'

const managerRoutes: RouteRecordRaw[] = [
  {
    path: '/manager',
    name: 'Manager',
    component: Layout,
    meta: {
      title: '系统管理',
      icon: 'vi-ep:user-filled',
      alwaysShow: true
    },
    children: [
      {
        path: 'list',
        component: () => import('@/views/Manager/ManagerList.vue'),
        name: 'ManagerList',
        meta: { title: '管理员账号' }
      },
      {
        path: 'role',
        component: () => import('@/views/Manager/RoleList.vue'),
        name: 'ManagerRoleList',
        meta: { title: '角色管理' }
      },
      {
        path: 'module',
        component: () => import('@/views/Manager/ModuleList.vue'),
        name: 'ManagerModuleList',
        meta: { title: '业务模块' }
      },
      {
        path: 'menu',
        component: () => import('@/views/Manager/MenuList.vue'),
        name: 'ManagerMenuList',
        meta: { title: '菜单导航' }
      },
      {
        path: 'permission',
        component: () => import('@/views/Manager/PermissionList.vue'),
        name: 'ManagerPermissionList',
        meta: { title: '权限规则' }
      }
    ]
  }
]

export default managerRoutes
